import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import AboutusBG from "../../../Assets/AboutUs_Img/about_background_img.webp";
import decorative_glass from "../../../Assets/AboutUs_Img/decorative-glass.webp";
import decorative_glass_1 from "../../../Assets/AboutUs_Img/decorative-glass-1.webp";
import decorative_glass_2 from "../../../Assets/AboutUs_Img/decorative-glass-2.webp";
import { Link } from "react-router-dom";

const Decorative_glass = () => {
  return (
    <div>
      <Header />
      {/* banner section start  */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${AboutusBG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h2><Link to='/AboutUs' className="text-decoration-none text-white">ABOUT US</Link> /<span className="text-white">  Decorative Glass</span></h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* banner section end */}

      {/* about tabbing section start  */}
      <section className="container-fluid about_Products_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="blog_text wow fadeInUp">
                <h5>Decorative Glass</h5>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting, remaining
                  essentially unchanged. It was popularised in the 1960s with
                  the release of Letraset sheets containing Lorem Ipsum
                  passages, and more recently with desktop publishing software
                  like Aldus PageMaker including versions of Lorem Ipsum.
                </p>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting, remaining
                  essentially unchanged. It was popularised in the 1960s with
                  the release of Letraset sheets containing Lorem Ipsum
                  passages, and more recently with desktop publishing software
                  like Aldus PageMaker including versions of Lorem Ipsum.
                </p>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting, remaining
                  essentially unchanged. It was popularised in the 1960s with
                  the release of Letraset sheets containing Lorem Ipsum
                  passages, and more recently with desktop publishing software
                  like Aldus PageMaker including versions of Lorem Ipsum.
                </p>
              </div>
              <div className="Products_img wow fadeInUp">
                <img src={decorative_glass} alt="Bus" />
                <img src={decorative_glass_1} alt="car" />
                <img src={decorative_glass_2} alt="staff-bus" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* about tabbing section End  */}

      <Footer />
    </div>
  );
};

export default Decorative_glass;
